const menuToggle = document.getElementById('menu-toggle');
const menu = document.getElementById('menu');
const openMenu = document.getElementById('openMenu');
const closeMenu = document.getElementById('closeMenu');
const navbar = document.getElementById('navbar');
const subscribeBtn = document.getElementById('subscribeBtn');
const chatToggle = document.getElementById('chat-contact-toggle');
const navItems = document.querySelectorAll('.nav--item');
const dropdowns = document.querySelectorAll('.nav-dropdown');
const dropdownsToggles = document.querySelectorAll('.toggleDropdown');
const dropdownList = document.querySelectorAll('.nav-dropdown-list');
const newsBanner = document.querySelector('.news-banner');
const removeNewsBanner = document.querySelector('.remove-news-banner');

let prevScrollpos = window.scrollY;

window.addEventListener('scroll', function (ev) {
	if (newsBanner) {
		let currentScrollPos = window.scrollY;
		if (currentScrollPos > prevScrollpos && currentScrollPos > 180) {
			newsBanner.style.maxHeight = 0;
			newsBanner.style.minHeight = 0;

			newsBanner.style.padding = 0;
		} else {
			if (window.scrollY === 0) {
				newsBanner.style.maxHeight = '';
				newsBanner.style.minHeight = '40px';
				newsBanner.style.padding = '12px';
			}
		}
		prevScrollpos = currentScrollPos;
	}
});

if (removeNewsBanner) {
	removeNewsBanner.addEventListener('click', () => {
		newsBanner.classList.add('hidden');
	});
}

subscribeBtn?.addEventListener('click', () => {
	menu.classList.toggle('block');
});

const toggleChanger = () => {
	menu.classList.toggle('hidden');
	if (!menu.classList.contains('hidden')) {
		chatToggle.classList.add('hidden');
		navbar.classList.add('-translate-y-full');
	} else {
		navbar.classList.remove('-translate-y-full');
		chatToggle.classList.remove('hidden');
	}
};

menuToggle?.addEventListener('change', toggleChanger);

const currPathName = decodeURIComponent(window.location.pathname);
navItems.forEach((el) => {
	const currLink = decodeURIComponent(el.href);
	if (
		currPathName !== '/' &&
		currPathName.trim() &&
		currLink.includes(currPathName)
	) {
		el.classList.add('underline');
		const currTitle = el
			.closest('.nav-dropdown')
			?.querySelector('.nav--item--dropdown--title');
		if (currTitle) currTitle.classList.add('underline');
	}
});

dropdownList?.forEach((el) => {
	el.addEventListener('mouseleave', () => {
		el.classList.remove('active');
		const parentElement = el.parentElement;
		parentElement.classList.remove('active');
	});
});

function toggleDropdowns(el) {
	return () => {
		// Close all dropdown submenus and remove border color
		dropdowns.forEach((dropdownParent) => {
			if (dropdownParent !== el) {
				dropdownParent.classList.remove('active');
			}
		});
		dropdownList.forEach((dropdown) => {
			if (dropdown !== el.querySelector('.nav-dropdown-list')) {
				dropdown.classList.remove('active');
			}
		});

		// toggle active class on the clicked dropdown
		el.querySelector('.nav-dropdown-list')?.classList.toggle('active');
		el.classList.toggle('active');
	};
}

dropdowns?.forEach((el) => {
	el.addEventListener('click', toggleDropdowns(el));
});

dropdownsToggles.forEach((it) => {
	it.addEventListener('keydown', (e) => {
		if (e.key === 'Enter' || e.key === ' ') {
			e.preventDefault();
			toggleDropdowns(it.closest('.nav-dropdown'))();
		}
	});
});

if (openMenu) {
	openMenu.addEventListener('keydown', (e) => {
		if (e.key === 'Enter' || e.key === ' ') {
			e.preventDefault();
			toggleChanger();
		}
	});
}

if (closeMenu) {
	closeMenu.addEventListener('keydown', (e) => {
		if (e.key === 'Enter' || e.key === ' ') {
			e.preventDefault();
			toggleChanger();
		}
	});
}


export default menuToggle;
